// extracted by mini-css-extract-plugin
module.exports = {"DangerButton":"_907O7YGGA+ltKPXhZRTP0w==","DangerButtonExtraSpecificity":"FlaC7VgeLcohZlDkjb3JBA=="};